import { useCallback } from "react";

interface UseScrollLock {
  lock: () => void;
  unlock: () => void;
}

/**
 * [2023.05.19]
 * ios web / ios app에서는 touchAction: none 속성 추가 필요
 */
export default function useScrollLock(): UseScrollLock {
  const preventDefault = (e: Event) => {
    e.preventDefault();
  };
  const lock = useCallback(() => {
    document.body.addEventListener("scroll", preventDefault, {
      passive: false,
    });
    document.body.style.overflowY = "hidden";
  }, []);
  const unlock = useCallback(() => {
    document.body.removeEventListener("scroll", preventDefault);
    document.body.style.overflowY = "";
  }, []);

  return { lock, unlock };
}
